const type = 'SET_SPENDING_LIMITS_LOADING';

const setSpendingLimitsLoading = (data) => ({
  data,
  type,
});

export { type };
export default setSpendingLimitsLoading;
